{
  "seo": {
    "title": "CuriPop — Fun Answers to Kids' Big Questions",
    "description": "CuriPop helps kids explore science, space, animals, and the world with fun, age-appropriate answers. Trusted by curious families everywhere.",
    "keywords": "kids questions, children learning, science for kids, educational app, fun facts for kids, curious kids, why questions",
    "jsonLdDescription": "Fun answers to kids' big questions about science, space, animals, and the world."
  },
  "hero": {
    "titlePrefix": "Every",
    "why": "\"Why?\"",
    "titleMiddle": "Deserves",
    "titleSuffix": "A Great Answer!",
    "tagline": "1,000+ questions answered!",
    "subtitle": {
      "prefix": "Fun, simple answers to the big questions kids ask. Perfect for curious kids ages",
      "suffix": "Continue where they left off every time they return."
    },
    "ctaPrimary": "Start Free",
    "ctaSecondary": "Browse Topics",
    "trust": {
      "coppa": "COPPA Compliant",
      "daily": "12 Free Daily",
      "continue": "Continue Where Left Off"
    },
    "imageAlt": "Happy diverse children learning together",
    "bubbles": {
      "sky": "Why is the sky blue?",
      "stars": "Why do stars twinkle at night?",
      "birds": "How do birds know where to fly?",
      "rainbow": "How does a rainbow happen?",
      "ocean": "Why is the ocean salty?"
    }
  },
  "features": {
    "realQuestions": {
      "title": "Real Questions, Real Answers",
      "description": "Real questions kids actually ask, answered with care and accuracy."
    },
    "ageAppropriate": {
      "title": "Age-Appropriate Learning",
      "description": "Content adapts to your child's reading level for the perfect challenge."
    },
    "families": {
      "title": "Built for Families",
      "description": "Create profiles for each child. Parents stay in control."
    },
    "safe": {
      "title": "Safe & Private",
      "description": "COPPA compliant. No ads. No data selling. Just learning."
    }
  },
  "samples": {
    "sky": "Why is the sky blue?",
    "airplanes": "How do airplanes stay up?",
    "dreams": "Why do we dream?",
    "magnets": "How do magnets work?",
    "leaves": "Why do leaves change color?",
    "fish": "How do fish breathe underwater?"
  },
  "steps": {
    "pick": {
      "title": "Pick a Question",
      "description": "Browse by topic or search for anything you're curious about!"
    },
    "read": {
      "title": "Read the Answer",
      "description": "Simple explanations that make sense. Can even read it aloud for you!"
    },
    "mindBlown": {
      "title": "Mind = Blown!",
      "description": "Fun facts and cool details that make you go \"Wow!\""
    }
  },
  "topics": {
    "science": {
      "title": "Science & Nature",
      "description": "Explore the wonders of our world",
      "count": "New topics daily"
    },
    "space": {
      "title": "Space & Universe",
      "description": "Journey through the cosmos",
      "count": "Endless discovery"
    },
    "body": {
      "title": "Human Body",
      "description": "Discover how you work",
      "count": "Growing library"
    },
    "animals": {
      "title": "Animals",
      "description": "Learn about amazing creatures",
      "count": "Always expanding"
    },
    "nature": {
      "title": "Nature",
      "description": "Explore weather, plants, and ecosystems",
      "count": "Always growing"
    },
    "technology": {
      "title": "Technology",
      "description": "Friendly explanations for modern tools",
      "count": "Ever evolving"
    }
  },
  "sections": {
    "popular": {
      "titlePrefix": "Popular",
      "titleHighlight": "Classes",
      "subtitle": "Explore topics that spark curiosity and wonder in young minds!"
    },
    "features": {
      "title": "Why Families Love Us",
      "subtitle": "Learning should be fun! We make curiosity an adventure."
    },
    "featured": {
      "title": "Questions Kids Are Asking",
      "subtitle": "Tap any card to discover the answer!",
      "cta": "Explore All Questions"
    },
    "how": {
      "title": "How It Works",
      "subtitle": "It's super easy to start learning!"
    },
    "testimonials": {
      "title": "What Families Are Saying"
    },
    "finalCta": {
      "title": "Ready for an Adventure?",
      "subtitle": "Start exploring with 12 free questions every day. Let's go!",
      "primary": "Start Free",
      "secondary": "Start Free"
    }
  },
  "about": {
    "titlePrefix": "Built by Parents,",
    "titleHighlight": "For Curious Kids",
    "paragraph1": "We believe every child's question deserves a real, thoughtful answer. That's why we created Curipop — a safe space where curiosity thrives and learning feels like an adventure.",
    "paragraph2": "Our team of educators, parents, and child development experts carefully craft every answer to be accurate, age-appropriate, and genuinely engaging.",
    "actions": {
      "learn": "Learn About Us",
      "families": "For Families"
    },
    "imageAltPrimary": "Teacher helping children learn",
    "imageAltSecondary": "Child excited about learning"
  },
  "testimonials": {
    "items": [
      {
        "quote": "Finally, answers I can trust! My daughter loves exploring the questions every night before bed.",
        "author": "Sarah M.",
        "role": "Mom of two kids"
      },
      {
        "quote": "The reading level adjustment is perfect. Both my 6-year-old and 10-year-old can use it.",
        "author": "Michael T.",
        "role": "Dad Engineer"
      },
      {
        "quote": "I use this with my students. The explanations are accurate and age-appropriate.",
        "author": "Jennifer L.",
        "role": "3rd Grade Teacher"
      }
    ]
  }
}
